import { render, staticRenderFns } from "./MenuConfig.vue?vue&type=template&id=8ec24324&scoped=true&"
import script from "./MenuConfig.vue?vue&type=script&lang=js&"
export * from "./MenuConfig.vue?vue&type=script&lang=js&"
import style0 from "./MenuConfig.vue?vue&type=style&index=0&id=8ec24324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec24324",
  null
  
)

export default component.exports